// extracted by mini-css-extract-plugin
module.exports = {"content":"Libraries_content__EumiA","contentLabel":"Libraries_contentLabel__1MLp5","contentDetail":"Libraries_contentDetail__Ey_OY"};